var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3433 25.9925H4.47887C3.2527 25.9925 2.38215 24.7977 2.75761 23.6304C3.75499 20.5294 6.8118 18.2853 10.2444 18.2853C11.8819 18.2853 13.4 18.796 14.6484 19.6667M13.9989 14.5123C15.4038 13.0262 17.3938 12.0989 19.6004 12.0989C21.2378 12.0989 22.7559 12.6096 24.0043 13.4803M6.55797 14.5518C6.55797 12.505 8.21731 10.8456 10.2642 10.8456C12.3111 10.8456 13.9704 12.505 13.9704 14.5518C13.9704 16.5987 12.3111 18.2581 10.2642 18.2581C8.21731 18.2581 6.55797 16.5987 6.55797 14.5518ZM15.9139 8.3654C15.9139 6.31852 17.5732 4.65918 19.6201 4.65918C21.667 4.65918 23.3263 6.31852 23.3263 8.3654C23.3263 10.4123 21.667 12.0716 19.6201 12.0716C17.5732 12.0716 15.9139 10.4123 15.9139 8.3654ZM16.4973 22.6737C16.4973 22.6737 18.8306 18.007 22.9139 18.007C26.9973 18.007 29.3306 22.6737 29.3306 22.6737C29.3306 22.6737 26.9973 27.3403 22.9139 27.3403C18.8306 27.3403 16.4973 22.6737 16.4973 22.6737ZM24.4138 22.6735C24.4138 23.502 23.7422 24.1735 22.9138 24.1735C22.0854 24.1735 21.4138 23.502 21.4138 22.6735C21.4138 21.8451 22.0854 21.1735 22.9138 21.1735C23.7422 21.1735 24.4138 21.8451 24.4138 22.6735Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewsIcon);
export default __webpack_public_path__ + "static/media/ViewsIcon.1b0e00dcf0d540be493c7f79fc28f65e.svg";
export { ForwardRef as ReactComponent };